






























































































































import Vue from 'vue';

export default Vue.extend({
  name: 'AdminBranchen',
  data() {
    return {
      todelete: 0,
      newbranche: ""
    }
  },
  methods: {
    remove: function(id: number){
      this.$store.dispatch('removeBranche', id);
    },
    confirm: function(id: number){
      this.todelete = id;
    },
    addnew: function(){
      if(this.newbranche != "") {
        this.$store.dispatch('addBranche', this.newbranche);
      }
    }
  },
  computed: {
    branchen: function() {
      return this.$store.getters.allBranchen;
    },
  }
});
